import React, { useEffect, useState } from 'react'
import TecnicheStampaTemplate from '../../../components/template/TecnicheStampaTemplate/TecnicheStampaTemplate'
import PropTypes from 'prop-types'
import { api, getApiClient } from '../../../utils'
import { PAGINEDETAIL, TECNICHE } from '../../../utils/endpoint'
import { useRouter } from 'next/router'

const TecnicheStampa = ({ page }) => {
  const [tecniche, setTecniche] = useState()
  const router = useRouter()
  useEffect(() => {
    api
      .get(TECNICHE, {
        params: {
          lang: router.locale,
        },
      })
      .then((response) => setTecniche(response.data))
  }, [])

  return (
    <>
      <TecnicheStampaTemplate page={page} tecnicheData={tecniche} />
    </>
  )
}

export async function getServerSideProps({ locale, req }) {
  const api = getApiClient(req)
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'tecniche-stampa',
        lang: locale,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page }

    return { props: { page, ...toolbarProps } }
  } catch (error) {
    return { props: { statusCode: 500 } }
  }
}

TecnicheStampa.propTypes = {
  page: PropTypes.object,
}

export default TecnicheStampa
